import React from 'react'
import _ from 'lodash'
import moment from 'moment/moment'
import { Line, Pie } from 'react-chartjs-2'

const statuses = {
  total: 'ทั้งหมด',
  open: 'เปิด',
  accept: 'รับเรื่องแล้ว',
  inprogress: 'กำลังปรับปรุง',
  done: 'ปรับปรุงแล้ว',
  close: 'ปิด',
  reopen: 'เปิดใหม่',
  delayed: 'เกินกำหนด',
  my: 'งานของฉัน'
}

const Summary = props => {
  const { projects } = props
  if (!projects) return (<div/>)
    return !(projects && projects.length > 0) ? (<div/>) : (_.map(projects, (project, i) => {
            const {name, defectHistory, defectSummary, activityLogs} = project
            const historyData = _.reduce(defectHistory, (result, value) => {
                result.remainingToday = value.count
                result.labels.push(moment(value.date).format('D ddd'))
                result.datasets[0].data.push(value.count)
                return result
            }, {
                labels: [],
                datasets: [{
                    label: 'งานที่กำลังดำเนินการ',
                    scaleStartValue: 0,
                    data: [],
                    fill: true,
                    backgroundColor: 'rgba(22, 106, 143, 0.6)',
                    borderColor: 'rgba(22, 106, 143)',
                    pointBackgroundColor: 'rgba(22, 106, 143)',
                    borderWidth: '1',
                    height: 500
                }]
            })
            const historyOptions = {
                scales: {yAxes: [{ticks: {beginAtZero: true, suggestedMax: _.max(historyData.datasets[0].data) + 1}}]}
            }
            let totalDefect = 0;
            const summaryData = _.reduce(defectSummary, (result, value, key) => {
                if (statuses[key]) {
                    totalDefect += value
                    result.labels.push(statuses[key])
                    result.datasets[0].data.push(value)
                }
                result.totalDefect = totalDefect;
                return result
            }, {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        'rgba(77, 201, 246, 0.8)',
                        'rgba(246, 112, 25, 0.8)',
                        'rgba(235, 39, 121, 0.8)',
                        'rgba(83, 123, 196, 0.8)',
                        'rgba(172, 194, 54, 0.8)',
                        'rgba(22, 106, 143, 0.8)',
                        'rgba(0, 169, 80, 0.8)',
                        'rgba(88, 89, 91, 0.8)',
                        'rgba(133, 73, 186, 0.8)'
                    ],
                    height: 500
                }]
            })
            return (
                <div className="pd-10">
                  <div className="br-pagebody">
                    <div class="card shadow-base bd-0 mg-t-20">
                      <div
                          class="card-header bg-transparent pd-x-25 pd-y-15 bd-b-0 d-flex justify-content-between align-items-center">
                        <h6 class="card-title tx-uppercase mg-b-0">{name}</h6>
                      </div>
                      <div class="card-body pd-x-25 pd-b-25 pd-t-0">
                        <div class="row no-gutters">
                          <div class="col-sm-12 col-lg-6">
                            <div class="card card-body rounded-0 bd-lg-l-0">
                              <h6 class="tx-inverse tx-14 mg-b-5">จำนวนงานทั้งหมด</h6>
                              <h3 class="tx-inverse tx-bold tx-lato">
                                <span>{summaryData.totalDefect}
                                  <small class="pd-l-5 tx-12 tx-uppercase tx-inverse tx-medium mg-b-0 tx-spacing-1">งาน</small>
                                </span>
                              </h3>
                              <div class="tx-center mg-y-10 mb-0">
                                <Pie data={summaryData} legend={{position: 'bottom'}} height={120}/>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 col-lg-6 mg-t--1 mg-sm-t-0 mg-lg-l--1">
                            <div class="card card-body rounded-0 bd-lg-l-0">
                              <h6 class="tx-inverse tx-14 mg-b-5">งานที่กำลังดำเนินการ</h6>
                              <h3 class="tx-inverse tx-bold tx-lato">
                                <span>{historyData.remainingToday}
                                  <small class="pd-l-5 tx-12 tx-uppercase tx-inverse tx-medium mg-b-0 tx-spacing-1">งาน</small>
                                </span>
                              </h3>
                              <div class="tx-center mg-y-10 mb-0">
                                <Line data={historyData} legend={{position: 'bottom'}} options={historyOptions} height={120} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                // <div>
                //   <div className="br-pagebody">
                //     <div className="br-section-wrapper">
                //       <div key={i} className="row col-md-12 card" style={{ marginBottom: '15px' }}>
                //         <div className="row card-header">โครงการ{name}</div>
                //         <div className="row card-body">
                //           <div className="col-md-6">
                //             <div className="row"><h5>Defect History</h5></div>
                //             <div className="row" style={{ marginRight: '5px', marginBottom: '15px' }}>
                //               <div className="card col-md-12" style={{ paddingTop: '10px' }}>
                //                 <Line data={historyData} legend={{ position: 'bottom' }} options={historyOptions}/>
                //               </div>
                //             </div>
                //             <div className="row"><h5>Defect Summary</h5></div>
                //             <div className="row" style={{ marginRight: '5px' }}>
                //               <div className="card col-md-12" style={{ paddingTop: '10px' }}>
                //                 <Pie data={summaryData} legend={{ position: 'bottom' }}/>
                //               </div>
                //             </div>
                //           </div>
                //           <div className="col-md-6">
                //             <div><h5>Activity Logs</h5></div>
                //             <div>
                //               {activityLogs && activityLogs.length > 0 ? _.map(activityLogs, (comment, j) => (
                //                 <div key={j} className="card" style={{ marginBottom: '15px' }}>
                //                   <div className="card-body color-gray-lighter">
                //                     <div className="">
                //                       {comment.comment}
                //                     </div>
                //                   </div>
                //                   <div className="card-footer">
                //                     <span className="">{moment(comment.updatedAt).fromNow()}</span>
                //                   </div>
                //                 </div>
                //               )) : 'No activities during the last 8 hours.'}
                //             {/*</div>*/}
                //           </div>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // </div>
            )
        }))
}

export default Summary



// WEBPACK FOOTER //
// ./src/components/Summary.js